export default "/images/select_opt_design_ad_creative.gif?e474eededaa6243f453f595f38300ae6";